import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {}

  removeItem(event) {
    event.preventDefault();
    this.element.remove();
  }
}
